module.exports = __webpack_public_path__ + "img/emp-data-icon2.973ff0fb.png";